export default {
  setClients(state, payload) {
    state.clients = payload;
  },
  setClientsCount(state, count) {
    state.clientsCount = count;
  },
  setClientsPagination(state, pagination) {
    state.pagination = pagination;
  },
  addClient(state, payload) {
    state.clients.unshift(payload);
  },
  updateClient(state, payload) {
    const index = state.clients.findIndex(
      item => item.clientName === payload.clientName
    );
    state.clients[index] = payload;
  },
  changeClientStatus(state, payload) {
    // payload.identifier is the joined users.username for this client.
    const index = state.clients.findIndex(
      item => item.username === payload.identifier
    );
    if (index !== -1) {
      // Normalize boolean (from base-toggle) and number callers to 0/1 so the
      // status filter `client.status === 1` keeps working without a reload.
      state.clients[index].status = payload.status ? 1 : 0;
    }
  }
};
